import React, { Component } from 'react';
import { Container, Header, Button, Checkbox, Form } from 'semantic-ui-react';

import NewNews from './NewNews';
import NewsList from './NewsList';
import PhotoUpload from './PhotoUpload';
import FileUpload from './FileUpload';
import EditNews from './EditNews';
import { DeleteData } from '../../api/Service';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
class Home extends Component {

    constructor(props) {
    super(props);

    this.state = {
      is_edit: false,
      edit_data: ''
    }
    
  }

  onEditClick(value){

    this.setState({
      is_edit: true,
      edit_data: value
    })
  }

  onDeleteClick(id){

    confirmAlert({
      title: 'Confirm to Delete',
      message: 'Are you sure to do this.',
      buttons: [
        {
          label: 'Yes',
          onClick: this._postData.bind(this, id)
        },
        {
          label: 'No',
          onClick: () => window.location.reload()
        }
      ]
    })
    
  }

  _postData(id){
    let user = localStorage.getItem('user');
        user = JSON.parse(user);
        let key = user.key;
        let user_id = user._user_.id;
        console.log(user_id);
        const data1 = {
          id: user_id
        }
    DeleteData(`api/news/${key}/delete/${id}/${user_id}`)
      .then((data) => {
        if (data.rows.affectedRows === 1) {
          confirmAlert({
            title: 'Successfully Deleted',
            message: 'Your news has been successfully deleted',
            buttons: [
              {
                label: 'Okay',
                onClick: () => window.location.reload()
              }
            ]
          })
        } else {
          confirmAlert({
            title: 'Something Went Wrong',
            message: 'Please Contact your administrator',
            buttons: [
              {
                label: 'Okay',
                onClick: () => window.location.reload()
              }
            ]
          })
        }
      })
  }
    
    render() {
        return (
            <div className="notice-home">

                <Header as='h1'>News Manager</Header>

                <div className="notice-grid">
                    <div>
                        <NewsList onEditClick={this.onEditClick.bind(this)} onDeleteClick={this.onDeleteClick.bind(this)} />
                    </div>
                    <div className="notice-form">
                        <div className="notice-form-element">
                            <h2>Add new News</h2>

            

                             {this.state.is_edit ? <EditNews data={this.state.edit_data} /> :<NewNews />}

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Home;


// WEBPACK FOOTER //
// ./src/HomeComponents/News/Home.js